import { IClassname } from '@/lib/shared/model/classname';

export const Simulator = ({ className }: IClassname) => {
  return (
    <svg
      width="32"
      className={className}
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.7922 2.2627H26.5429C27.5596 2.2627 28.5348 2.66661 29.2537 3.38557C29.9727 4.10454 30.3766 5.07967 30.3766 6.09645C30.3766 7.11322 29.9727 8.08835 29.2537 8.80732C28.5348 9.52628 27.5596 9.93019 26.5429 9.93019H25.9039C24.8598 9.93019 23.9308 9.79346 23.3481 10.5692L17.4441 21.733"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.3896 27.8206C22.9546 27.8195 23.4982 27.6046 23.9113 27.2191C24.3243 26.8336 24.5761 26.3061 24.6161 25.7425C24.6561 25.1789 24.4812 24.6211 24.1268 24.1811C23.7723 23.7412 23.2644 23.4517 22.7052 23.3709L18.3003 22.0188C17.5647 21.8842 16.8997 21.4959 16.421 20.9215C15.9423 20.3471 15.6803 19.6229 15.6805 18.8752V16.3193H8.65199C7.12683 16.3193 5.66414 16.9252 4.58569 18.0037C3.50723 19.0821 2.90137 20.5448 2.90137 22.07C2.90137 23.5951 3.50723 25.0578 4.58569 26.1363C5.66414 27.2147 7.12683 27.8206 8.65199 27.8206H22.3896Z"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.6521 22.0702C8.6521 22.5786 8.85406 23.0661 9.21354 23.4256C9.57302 23.7851 10.0606 23.9871 10.569 23.9871C11.0774 23.9871 11.5649 23.7851 11.9244 23.4256C12.2839 23.0661 12.4858 22.5786 12.4858 22.0702C12.4858 21.5618 12.2839 21.0742 11.9244 20.7148C11.5649 20.3553 11.0774 20.1533 10.569 20.1533C10.0606 20.1533 9.57302 20.3553 9.21354 20.7148C8.85406 21.0742 8.6521 21.5618 8.6521 22.0702Z"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.9233 23.4258L13.7635 25.2647"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.8467 25.2646H15.0415"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.54041 6.0957C3.03202 6.0957 2.54446 6.29766 2.18497 6.65714C1.82549 7.01663 1.62354 7.50419 1.62354 8.01258C1.62354 8.52097 1.82549 9.00853 2.18497 9.36801C2.54446 9.7275 3.03202 9.92945 3.54041 9.92945H10.2495C10.4787 9.92759 10.6997 9.84375 10.8724 9.6931C11.0452 9.54246 11.1583 9.33495 11.1914 9.10812C11.2244 8.88129 11.1752 8.65013 11.0526 8.45645C10.93 8.26277 10.7421 8.11937 10.5229 8.05219C10.1051 7.92824 3.97746 6.0957 3.54041 6.0957Z"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.09619 9.92969L11.8468 16.3193"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.01307 27.8203L6.09619 29.7372"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.9871 27.1816L26.5429 29.7375"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
